import PagesMaintenance from "pages/Utility/pages-maintenance";

const WalletTransactions = () => {
  return (
    <PagesMaintenance />
  );
};

export default WalletTransactions;
